export const SET_COURSES = 'course/SET_COURSES';
export const SET_ACTIVE_COURSE_MEMBERS = 'course/SET_ACTIVE_COURSE_MEMBERS';
export const SET_ACTIVE_COURSE = 'course/SET_ACTIVE_COURSE';
export const UPDATE_COURSE_SETTINGS = 'course/UPDATE_COURSE_SETTINGS';
export const ADD_COURSE = 'course/ADD_COURSE';
export const ADD_COURSE_MEMBER = 'course/ADD_COURSE_MEMBER';
export const UPDATE_COURSE_MEMBER = 'course/UPDATE_COURSE_MEMBER';
export const DELETE_COURSE_MEMBER = 'course/DELETE_COURSE_MEMBER';